import userTypes from './types';

export const initialStates = {
	session: null,
	users: [],
	otpToken: '',
	forgetPassword: null,
	selectedBusinessId: '',
	profile: {},
	updateProfile: null,
	updateProfileOtp: null,
	updateProfileOtpConfirm: null,
	signupOtpConfirm: null,
	wizard: null,
	asnaafLogin: null,
	asnaafOtp: null,
	registerFresh: null,
	completeProfile: null,
};

const userReducers = (state = initialStates, action) => {
	switch (action.type) {
		case userTypes.LOGIN.SUCCESS: {
			return { ...state, ...handleLoginSuccess(action?.payload) };
		}

		case userTypes.GET_PROFILE.SUCCESS: {
			return { ...state, completeProfile: action?.payload?.data?.attributes };
		}

		case userTypes.UPDATE_PROFILE.SUCCESS: {
			return {
				...state,
				...getUsersInfoByLogin(action?.payload),
			};
		}

		case userTypes.ASNAAF_OTP.SUCCESS: {
			return { ...state, asnaafOtp: action?.payload };
		}

		case userTypes.ASNAAF_OTP.CLEAR: {
			return { ...state, asnaafOtp: null };
		}

		case userTypes.REGISTER_FRESH.SUCCESS: {
			return { ...state, registerFresh: action?.payload };
		}

		case userTypes.REGISTER_FRESH.CLEAR: {
			return { ...state, registerFresh: null };
		}

		case userTypes.ASNAAF_LOGIN.SUCCESS: {
			return { ...state, asnaafLogin: action?.payload };
		}

		case userTypes.ASNAAF_LOGIN.CLEAR: {
			return { ...state, asnaafLogin: null };
		}

		case userTypes.FORGET_PASSWORD.SUCCESS: {
			return { ...state, forgetPassword: action?.payload?.msg };
		}

		case userTypes.FORGET_PASSWORD.CLEAR: {
			return { ...state, forgetPassword: null };
		}

		case userTypes.CREATE_OTP.SUCCESS: {
			return {
				...state,
				...handleSignupSuccess(action?.payload),
			};
		}

		case userTypes.SESSION.SELECT_BUSINESS: {
			const businessId = action?.payload;
			const selectedSession = state.users.find(
				(user) =>
					user?.business_id == businessId || user?.business?.id == businessId
			);
			return {
				...state,
				session: selectedSession,
				selectedBusinessId: businessId,
			};
		}

		case userTypes.SESSION.LOGOUT: {
			return { ...initialStates };
		}

		case userTypes.PROFILE.SUCCESS: {
			return { ...state, profile: action?.payload?.data };
		}
		case userTypes.PROFILE_UPDATE.SUCCESS: {
			return { ...state, updateProfile: action?.payload };
		}

		case userTypes.PROFILE_UPDATE.CLEAR: {
			return { ...state, updateProfile: null };
		}

		case userTypes.CHANGE_NUMBER_OTP.SUCCESS: {
			return { ...state, updateProfileOtp: action?.payload };
		}

		case userTypes.CHANGE_NUMBER_OTP_CONFIRM.SUCCESS: {
			return { ...state, updateProfileOtpConfirm: action?.payload };
		}

		case userTypes.CHANGE_NUMBER_OTP.CLEAR: {
			return { ...state, updateProfileOtp: null };
		}

		case userTypes.CHANGE_NUMBER_OTP_CONFIRM.CLEAR: {
			return { ...state, updateProfileOtpConfirm: null };
		}

		case userTypes.WIZARD.SUCCESS: {
			return { ...state, wizard: action?.payload?.data };
		}

		case userTypes.WIZARD.CLEAR: {
			return { ...state, wizard: null };
		}

		default:
			return state;
	}
};

export default userReducers;

const handleLoginSuccess = (payload) => {
	if (
		payload?.setUser &&
		(payload?.user?.role_name === 'merchant' ||
			payload?.user?.role_name === 'fresh_merchant')
	) {
		return getUsersInfoByLogin(payload?.user);
	} else if (payload?.setOtp) {
		return { otpToken: payload?.otp_token };
	}
};

const handleSignupSuccess = (payload) => {
	if (payload?.setUser) {
		return getUsersInfoByLogin(payload?.user);
	} else {
		return {
			signupOtpConfirm: payload?.user,
			session: null,
			users: [],
			selectedBusinessId: '',
		};
	}
};
const getUsersInfoByLogin = (user) => {
	let users = [user],
		session = user,
		selectedBusinessId = user?.business_id;

	if (user?.super_user) {
		const subUsers = user.sub_users.map((user) => user.attributes);
		users.push(...subUsers);
	}

	return { users, session, selectedBusinessId };
};
